import React, { HTMLAttributes, RefObject, useContext, useEffect, useRef } from 'react';
import clsx from 'clsx';

import { TabsContext } from './TabsContext';

import styles from './tab.module.css';

export type TabProps = {
  label: string,
  index: number,
  tabTd: string,
  panelId: string
  disabled?: boolean
} & HTMLAttributes<HTMLButtonElement>

export const Tab = ({ label, index, tabTd, panelId, className, ...props }: TabProps) => {
  const ref = useRef<HTMLButtonElement | null>(null)
  const {isActive, setCurrentIndex, tabProps} = useTab(ref, index, tabTd, panelId)
  
  return (
    <button
      ref={ref}
      className={clsx(styles.button, isActive && styles.active, className)}
      {...(!isActive && {tabIndex: -1})}
      {...tabProps}
      {...props}
      onClick={() => setCurrentIndex(index)}>
      {label}
    </button>
  )
};

export const useTab = (ref: RefObject<HTMLButtonElement | null>, index: number, tabId: string, panelId: string) => {
  const {currentIndex, setCurrentIndex, isInit} = useContext(TabsContext)
  const isActive = currentIndex == index

  useEffect(() => {
    if (isInit && isActive) {
      ref.current?.focus()
    }

  }, [isActive, ref, isInit])

  return {
    isActive,
    currentIndex,
    setCurrentIndex,
    tabProps: {
      role: 'tab',
      type: 'button',
      id: `${tabId}-${index}`,
      'aria-selected': isActive,
      'aria-controls': `${panelId}-${index}`,
      ...(!isActive && {tabIndex: -1})
    }
  } as const
}
